import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";

import { useEffect } from "react";
import Contact from "./pages/Contact";
import DatasetAsianStock from "./pages/DatasetAsianStock";
import DatasetCrypto from "./pages/DatasetCrypto";
import DatasetForex from "./pages/DatasetForex";
import Datasets from "./pages/Datasets";
import DatasetUSStock from "./pages/DatasetUSStock";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import StockList from "./pages/StockList";
import ThankYou from "./pages/ThankYou";

const App: React.FC = () => {
  const ScrollToTop: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0); // Scrolls to the top of the page
    }, [location]); // Runs every time the route changes

    return null; // This component does not render anything
  };
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/datasets" element={<Datasets />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/thank-you" element={<ThankYou />} />

        <Route path="/datasets/crypto" element={<DatasetCrypto />} />
        <Route path="/datasets/forex" element={<DatasetForex />} />
        <Route path="/stock-list" element={<StockList />} />
        <Route path="/datasets/us-stock" element={<DatasetUSStock />} />
        <Route path="/datasets/asian-stock" element={<DatasetAsianStock />} />
      </Routes>
    </Router>
  );
};

export default App;
